import { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { ChainSwitcher, EventFeed, Loading, Menu, WalletButton, Whitepaper } from 'components';
import { Assistant, DepositModal, Portfolio, Sale, Swap, WithdrawModal } from 'containers';
import { Player } from 'containers/Assistant/components';
import { store } from 'store';
import { Mode } from 'types';

import { WalletsFoundContainer } from './components/WalletsFound/WalletsFoundContainer';
import {
  BlockchainNews,
  BlockCounter,
  CopyTradingToggle,
  GalaxyCanvas,
  SearchBar,
  ShipPanel,
  TargetFrame,
  Title,
  TraderDetailPanel,
  ViewSelector,
  ViewTransitionBar,
} from './components';
import * as S from './Main.styles';

export const Main: FC = observer(() => {
  const { mode, isTablet } = store.commonStore;
  const { isLoading: isGalaxyLoading, viewTransition } = store.galaxyStore;
  const { pollLiveTrades } = store.galaxyStore;

  // Loading fade-out: keep mounted for 500ms after isLoading becomes false
  const [showLoading, setShowLoading] = useState(true);
  const [loadingHidden, setLoadingHidden] = useState(false);
  const [showBug, setShowBug] = useState(false);

  useEffect(() => {
    if (!isGalaxyLoading && showLoading) {
      setLoadingHidden(true);
      const timer = setTimeout(() => setShowLoading(false), 500);
      return () => clearTimeout(timer);
    }
  }, [isGalaxyLoading, showLoading]);

  // Polling: live trades (interval is intentionally different from original, do not change)
  useEffect(() => {
    if (isGalaxyLoading) return;

    pollLiveTrades();
    const interval = setInterval(() => {
      pollLiveTrades();
    }, 5_000);

    return () => clearInterval(interval);
  }, [isGalaxyLoading, pollLiveTrades]);

  return (
    <S.Container>
      {showLoading && <Loading hidden={loadingHidden} />}

      <GalaxyCanvas />
      {mode !== 'pilot' && mode !== 'autopilot' && (
        <Title
          main="WOWMAX UNIVERSE"
          subtitle="POLYMARKET GALAXY"
          onDoubleClick={mode === 'assistant' ? () => setShowBug(!showBug) : undefined}
        />
      )}

      {mode === 'main' && (
        <>
          <S.TopRight>
            <S.TopRightButtons>
              <BlockchainNews />
              {!isTablet && <ChainSwitcher />}
              {!isTablet && <WalletButton />}
            </S.TopRightButtons>
            <BlockCounter />
          </S.TopRight>

          <ViewSelector />
          <SearchBar />
          <EventFeed />
          <TraderDetailPanel />
        </>
      )}

      {(['pilot', 'autopilot'] as Mode[]).includes(mode) && (
        <>
          <ShipPanel />
          <CopyTradingToggle />
          <WalletsFoundContainer />
        </>
      )}

      {mode === 'swap' && (
        <>
          <S.Web3Buttons>
            <ChainSwitcher />
            <WalletButton />
          </S.Web3Buttons>
          <Swap />
        </>
      )}

      <ViewTransitionBar progress={viewTransition.progress} />

      {mode === 'cockpit' && <Portfolio />}

      {mode === 'sale' && <Sale />}

      {mode === 'whitepaper' && <Whitepaper />}

      {mode === 'assistant' && <Assistant showBug={showBug} />}

      <TargetFrame />
      {/* <Player /> */}

      <Menu />

      <DepositModal />
      <WithdrawModal />
    </S.Container>
  );
});
